import { HStack } from "@chakra-ui/react";
import CDS from "design-system";
import { IconType } from "react-icons";
import colors from "theme/colors";

interface QuickActionButtonProps {
  icon: IconType;
  label: string;
  onClick: () => void;
}

export default function QuickActionButton({ icon: Icon, label, onClick }: QuickActionButtonProps) {
  return (
    <HStack
      p={3}
      bg="gray.50"
      borderRadius="md"
      cursor="pointer"
      _hover={{ bg: "gray.100" }}
      onClick={onClick}
    >
      <Icon size={18} color={colors.brand.DEFAULT} />
      <CDS.Text12 fontWeight="medium" color="content.primary">
        {label}
      </CDS.Text12>
    </HStack>
  );
}
